export default function image(
  media: App.Data.MediaData | null | undefined,
  type: keyof App.Data.MediaData = "original"
): string {
  let src = "";

  if (!media || typeof media !== "object") return src;

  if (type in media && media[type]) {
    src = media[type] as string;
  } else {
    for (const key in media) {
      if (media[key]) {
        src = media[key];
        break;
      }
    }
  }

  if (!src) return "";
  if (src.startsWith("http")) return src;
  return `${window.location.origin}/storage/${src}`;
}
